module.exports = __webpack_public_path__ + "static/media/logo-roan-t.13814ad5.png";